import React from 'react'

import Badge from '@/modules/base/components/badge/badge'
import { getReceiptState, getReceiptStateColor } from '@/modules/receipt/_helpers/receiptState'
import { receiptStates } from '@/modules/base/util/constants'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  badge: {
    fontSize: theme.fontSizes.default,
  },
}))

// FLAG:useDocuAi — review hosts can display the persisted document-review status here. Everyone
// else keeps the receipt state's own label unchanged.
const ReceiptStateBadge = (props: { state: keyof typeof receiptStates, labelOverride?: string }) => {
  const classes = useStyles()
  const {
    state,
    labelOverride,
  } = props

  const parsedState = getReceiptState(state)
  const badgeColor = getReceiptStateColor(state)

  return (
    <Badge label={labelOverride || parsedState} color={badgeColor} customClass={classes.badge} />
  )
}

export default ReceiptStateBadge
